import Relay from 'react-relay';
/**
*  Validate User mutation
*/
export default class UpdateUserMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation{
      validateUser
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
      user: {
        isTrustedUserToCreateCircles: this.props.validatePublicGroups,
        isTrustedUserToCreateActivities: this.props.validatePublicActivities,
      },
      userID: this.props.user.id,
    };
  }
  /**
  *  Fat query
  */

  getFatQuery() {
    return Relay.QL`
      fragment on validateUserPayload @relay(pattern: true){
        viewer {
          id
        }
        user {
          id
        }
      }
    `;
  }

  /**
  *  Config
  */
  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        viewer: this.props.viewer.id,
        user :this.props.user.id,
      },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
        id
      }
    `,
  }
}



// WEBPACK FOOTER //
// ./src/mutations/User/ValidateUserMutation.js